import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/fornecedorservicos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;
const headers = new Headers();
headers.append("Authorization", token);

export async function findFornecedorServicos() {
  return search(path, "GET", headers);
}
